import UserResult from "../components/users/UserResult";
import UserSearch from "../components/users/UserSearch";

const Home = () => {
  return (
    <>
      <UserSearch />
      <UserResult />
    </>
  );
};

export default Home;
